import { today,options } from "../services/AppService"
export class CardModel {
    colclass = undefined;
    colsize = undefined;
    hide = undefined;
    ID: string = "0";
    FourthName: string = '';
    F_Name: string = '';
    M_Name: string = '';
    L_Name: string = '';
    LastName: string = '';
    Sex: boolean = false;
    //PhoneNumber: string ='';
    Card_Phone: string = '';
    MotherName: string = '';
    Expiration_Date: string = today(-180);
    PlaceOfBirth: string = '';
    BirthdayDate: string = today(-365 * 15);
    Identity_Kind: string = '1';
    Identity_No: string = '';
    Card_Address: string = '';
    Nationality_id: string = '1';
    BranchID: string = options().userBranch;
    Card_Kind: string = '0';
    Card_Mob: string = "";
    CustomerType: boolean = false;
    IssuedBy: string = "";
    IssuedDate: string = today(+1);
    Card_Jop: string = '0';
    Note: string = "";
    SourceIncome: string = '0';
    Annual_Income: string = '0';
    Currency_Id: string = '1';
    Living_Card_No: string = "";
    Living_Card_Issue_Date: string = today();
    Living_Card_Issuer: string = "";
    Identity_Asylum_No: string = "";
    Identity_Asylum_Issue_Date: string = today();
    Identity_Asylum_Issuer: string = "";
    AddressCountry: string = '0';
    AddressCity: string = '0';
    AddressArea: string = '0';
    Address_District: string = "";
    AddressStreet: string = "";
    Address_Det: string = "";
    Document_Image?: string = undefined
    Check_Document_Image: boolean = false;
    LastPrintDate: string = "";
    constructor(public FirstName: string="") { }
}

export class CardFieldObject {
    Show= false;
    Required= false
}
export class CardFields {
    Address = new CardFieldObject();
    BirthdayDate = new CardFieldObject();
    PlaceOfBirth = new CardFieldObject();
    IdentificationKind = new CardFieldObject();
    IdentificationNumber = new CardFieldObject();
    MotherName = new CardFieldObject();
    DateIssue = new CardFieldObject();
    IssuedFrom = new CardFieldObject();
    DataExpir = new CardFieldObject();
    SourceIncome = new CardFieldObject();
    MonthlyIncome = new CardFieldObject();
    Currency = new CardFieldObject();
    Work = new CardFieldObject();
    WorkStatement = new CardFieldObject();
    HousingCardNo = new CardFieldObject();
    HouseDateIssued = new CardFieldObject();
    HouseIssuer = new CardFieldObject();
    AsylumIdentityNo = new CardFieldObject();
    AsylumDateIssued = new CardFieldObject();
    AsylumIssuer = new CardFieldObject();
}